const React = require('react');
const { createElement: h } = React;
require('./LegalPage.css');

function LegalPage(props) {
  var title = props.title || '';
  var lastUpdated = props.lastUpdated || '';
  var sections = Array.isArray(props.sections) ? props.sections : [];
  var onBack = typeof props.onBack === 'function' ? props.onBack : null;

  return h('div', { className: 'legal-page' },
    h('div', { className: 'legal-page__container' },
      onBack ? h('button', { className: 'legal-page__back', onClick: onBack, type: 'button' }, '\u2190 Tilbage') : null,
      h('h1', { className: 'legal-page__title' }, title),
      lastUpdated ? h('p', { className: 'legal-page__date' }, 'Sidst opdateret: ' + lastUpdated) : null,
      sections.map(function(section, i) {
        return h('div', { key: i, className: 'legal-page__section' },
          section.heading ? h('h2', { className: 'legal-page__heading' }, section.heading) : null,
          Array.isArray(section.paragraphs)
            ? section.paragraphs.map(function(p, j) {
                return h('p', { key: j, className: 'legal-page__text' }, p);
              })
            : null,
          Array.isArray(section.list)
            ? h('ul', { className: 'legal-page__list' },
                section.list.map(function(item, k) {
                  return h('li', { key: k }, item);
                })
              )
            : null
        );
      })
    )
  );
}

module.exports = LegalPage;
